<template>
    <!-- form fields for the contact section -->
    <div>
        <!-- THE CONTACT : lastname -->
        <el-form-item prop="name" :label="$t.__('common.labels.name')">
            <el-input
                name="lastname"
                autocomplete="off"
                v-model="name"
                :data-bot="getDatabot('lastname', $attrs.dataBotsContext, null, 'contact-popup')"
            ></el-input>
        </el-form-item>
        <!-- THE CONTACT : name -->
        <el-form-item prop="forename" :label="$t.__('common.labels.first_name')">
            <el-input
                name="firstname"
                autocomplete="off"
                v-model="forename"
                :data-bot="getDatabot('firstname', $attrs.dataBotsContext, null, 'contact-popup')"
            ></el-input>
        </el-form-item>
        <!-- THE CONTACT : E-MAIL -->
        <el-form-item prop="email" :label="$t.__('common.labels.email')">
            <el-input
                type="email"
                autocomplete="off"
                v-model="email"
                @input="checkIfContactExists()"
                :data-bot="getDatabot('email', $attrs.dataBotsContext, null, 'contact-popup')"
            ></el-input>
            <div class="alert alert-warning mt-3" v-if="getContactsList.length > 0">
                {{ $l10n.__('Ce contact semble déjà exister sur cette société') }}
            </div>
            <form-fields-contacts-list
                mode="readOnly"
                readonly
                :currentList="getContactsList"
                :displayNbSuggestion="false"
            />
        </el-form-item>
    </div>
</template>

<script>
import FormFieldsContactsList from 'vcomponents/thirds/thirdscomponents/FormFieldsContactsList.vue';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';

export default {
    mixins: [DataBotsFormsMixins],
    props: {
        currentStore: {
            type: String,
            required: true,
        },
    },
    components: {
        FormFieldsContactsList,
    },
    computed: {
        name: {
            get() {
                return this.$store.getters[`${this.currentStore}/getName`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setName`, value);
            },
        },
        forename: {
            get() {
                return this.$store.getters[`${this.currentStore}/getForename`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setForename`, value);
            },
        },
        email: {
            get() {
                return this.$store.getters[`${this.currentStore}/getEmail`];
            },
            set(value) {
                this.$store.commit(`${this.currentStore}/setEmail`, value);
            },
        },
        getContactsList() {
            return this.$store.getters[`${this.currentStore}/getContactsList`];
        },
    },
    methods: {
        checkIfContactExists() {
            if (this.email && this.email.length > 4) {
                this.$store.dispatch(`${this.currentStore}/checkIfContactExists`, this.email);
            }
        },
    },
};
</script>
